import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/consolidated/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Layouts from "../../layouts/layouts";
import SalaryDetailModal from "../../components/consolidated/Consolidated Details";
import * as XLSX from "xlsx";
import Switch from "react-switch";
import ConsolidatedDetailModal from "../../components/consolidated/Consolidated Details";

export default function Salaryhistory() {
  const title = "Consolidated Data Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);
  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showConsolidatedDetailModal, setShowConsolidatedDetailModal] =
    useState(false);
  const [selectedConsolidated, setSelectedConsolidated] = useState(null);

  // Filter states
  const prevMonthDate = new Date();
  prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);

  const [filterYear, setFilterYear] = useState(prevMonthDate.getFullYear());
  const [filterMonth, setFilterMonth] = useState(prevMonthDate.getMonth() + 1);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const columns = [
    {
      name: <b>Year / Month</b>,
      selector: (row) => `${row.year} / ${String(row.month).padStart(2, "0")}`,
      sortable: true,
    },

    {
      name: <b>Total Amount</b>,
      selector: (row) => (row.total ? Math.round(row.total) : "-"),
      sortable: true,
    },
    {
      name: <b>Direct Salary</b>,
      selector: (row) =>
        row.salary?.direct ? Math.round(row.salary.direct) : "-",
      sortable: true,
    },
    {
      name: <b>In-Direct Salary</b>,
      selector: (row) =>
        row.salary?.indirect ? Math.round(row.salary.indirect) : "-",
      sortable: true,
    },
    {
      name: <b>Direct Expenses</b>,
      selector: (row) =>
        row.expenses?.direct ? Math.round(row.expenses.direct) : "-",
      sortable: true,
    },
    {
      name: <b>In-Direct Expenses</b>,
      selector: (row) =>
        row.expenses?.indirect ? Math.round(row.expenses.indirect) : "-",
      sortable: true,
    },
    {
      name: <b>Damages</b>,
      selector: (row) => (row.damages ? Math.round(row.damages) : "-"),
      sortable: true,
    },
    {
      name: <b>Lease</b>,
      selector: (row) => (row.lease ? Math.round(row.lease) : "-"),
      sortable: true,
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <button
          onClick={() => viewConsoldiatedhistory(row)}
          className="btn btn-primary btn-sm"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      ),
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  //Previous Month data not Available then, show latest month data
  const fetchData = async (yearParam, monthParam) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const fetchSalary = async (year, month) => {
        let url = `${process.env.REACT_APP_BASE_URL}/api/v4/consolidated-expenses`;

        // Append query params if year & month are provided
        if (year && month) {
          url += `?year=${year}&month=${month}`;
        }

        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        return response.data;
      };

      // ✅ If no params, fetch all data
      if (!yearParam && !monthParam) {
        const allData = await fetchSalary(); // no params
        if (Array.isArray(allData) && allData.length > 0) {
          setApiState(allData);
          setApiCol(columns);
        } else {
          Swal.fire({
            icon: "info",
            title: "No Data Found",
            text: "No consolidated salary data available.",
          });
        }
        return;
      }

      // ✅ If year & month provided, do the usual logic
      let data = await fetchSalary(yearParam, monthParam);

      if (Array.isArray(data) && data.length > 0) {
        setApiState(data);
        setApiCol(columns);
        return;
      }

      // Search last 12 months
      const today = new Date();
      for (let i = 0; i < 12; i++) {
        const tryDate = new Date(today.getFullYear(), today.getMonth() - i, 1);
        const tryYear = tryDate.getFullYear();
        const tryMonth = tryDate.getMonth() + 1;

        if (tryYear === yearParam && tryMonth === monthParam) continue;

        const tryData = await fetchSalary(tryYear, tryMonth);
        if (Array.isArray(tryData) && tryData.length > 0) {
          setApiState(tryData);
          setApiCol(columns);
          Swal.fire({
            icon: "info",
            title: "Showing Latest Available Data",
            text: `No data for ${monthParam}/${yearParam}. Showing data for ${tryMonth}/${tryYear}`,
          });
          return;
        }
      }

      // If all failed
      Swal.fire({
        icon: "info",
        title: "No Data Found",
        text: "No salary data available for any recent months.",
      });
    } catch (error) {
      console.error("Error fetching salary history:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while fetching data.",
      });
    }
  };

  useEffect(() => {
    fetchData(); // Initial load
  }, []);

  const viewConsoldiatedhistory = (consolidated) => {
    setSelectedConsolidated(consolidated);
    setShowConsolidatedDetailModal(true);
  };
  const exportToExcel = () => {
    const transformedData = apistate.map((row) => ({
      Year: row.year,
      Month: row.month,
      "Direct Salary": row.salary?.direct ?? "-",
      "In-Direct Salary": row.salary?.indirect ?? "-",
      "Direct Expenses": row.expenses?.direct ?? "-",
      "In-Direct Expenses": row.expenses?.indirect ?? "-",
      Damages: row.damages,
      Lease: row.lease,
      Total: row.total,
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Consolidated Expenses");
    XLSX.writeFile(workbook, "consolidated_expenses.xlsx");
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />

      <ConsolidatedDetailModal
        show={showConsolidatedDetailModal}
        onHide={() => setShowConsolidatedDetailModal(false)}
        consolidated={selectedConsolidated}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="id_user.name"
                    apidata={apistate}
                    columns={apicol}
                    viewConsolidatedhistory={viewConsoldiatedhistory}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
